var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"width":"24","height":"24","fill":"#4C4541","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M2 6h2v2H2V6zM6 8V6h16v2H6zM2 11h2v2H2v-2zM6 13v-2h16v2H6zM2 16h2v2H2v-2zM6 18v-2h16v2H6z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }